import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  fetchInterceptionRules,
  createInterceptionRule,
  updateInterceptionRule,
  toggleInterceptionRule,
  deactivateInterceptionRule,
} from "@/services/payout.service";

export const useInterceptionRules = () =>
  useQuery({
    queryKey: ["interception-rules"],
    queryFn: fetchInterceptionRules,
  });

export const useCreateInterceptionRule = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: createInterceptionRule,
    onSuccess: () => qc.invalidateQueries({ queryKey: ["interception-rules"] }),
  });
};

export const useUpdateInterceptionRule = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: updateInterceptionRule,
    onSuccess: () => qc.invalidateQueries({ queryKey: ["interception-rules"] }),
  });
};

export const useToggleInterceptionRule = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: toggleInterceptionRule,
    onSuccess: () => qc.invalidateQueries({ queryKey: ["interception-rules"] }),
  });
};

export const useDeactivateInterceptionRule = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: deactivateInterceptionRule,
    onSuccess: () => qc.invalidateQueries({ queryKey: ["interception-rules"] }),
  });
};